
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CustomerComponent } from './customer.component';

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule} from '@angular/forms'
import {RouterModule} from "@angular/router";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatButtonModule} from "@angular/material/button";
import {CustomerFormComponent} from "./customerForm.component";
import {MatSelectModule} from "@angular/material/select";
import {FuseSidebarModule} from "../../../@fuse/components";
import {CustomerMainSidebarComponent} from "./sidebars/main/main-sidebar.component";
import {FuseSharedModule} from "../../../@fuse/shared.module";
import {MatRippleModule} from "@angular/material/core";
import {TranslateModule} from "@ngx-translate/core";
import {CustomerDetailsSidebarComponent} from "./sidebars/details/details-sidebar.component";
import {CustomerDetailsComponent} from "./customerDetails.component";
import {CustomerPersonalDataComponent} from "./customerPersonalData.component";
import {CustomerDialogComponent} from "./dialog/customerDialog.component";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatDialogModule} from "@angular/material/dialog";
import {MatTooltipModule} from "@angular/material/tooltip";
import {CustomerContactDetailsDialogComponent} from "./dialog/customerContactDetailsDialog.component";
import {CustomerDescriptionEditDialogComponent} from "./dialog/customerDescriptionEditDialog.component";
import {CustomerCardsSidebarComponent} from "./sidebars/cards/cards-sidebar.component";
import {CustomerCardsComponent} from "./customerCards.component";
import {AddCardComponent} from "./addCard.component";
import {AddCardItemComponent} from "./addCardItem.component";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {ResourcesInUseComponent} from "./resourcesInUse.component";
import {MinusServiceDialogComponent} from "./dialog/minusServiceDialog.component";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {ExitCardDialogComponent} from "./dialog/exitCardDialog.component";
import {MatTreeModule} from "@angular/material/tree";
import {CustomerResourcesSidebarComponent} from "./sidebars/resources/resources-sidebar.component";
import {ResourceOnlineComponent} from "./resourceOnline.component";
import {SecurityModule} from "../security/security.module";
import {CustomerCommunicationComponent} from "./customerCommunication.component";
import {OrdersComponent} from "./orders.component";
import {CustomerResolve} from "./resolvers/customer.resolve";
import {TakeCardDialogComponent} from "./dialog/takeCardDialog.component";
import {CustomerAlreadyExistsDialogComponent} from "./dialog/customerAlreadyExistsDialog.component";
import {WorkTimeModule} from "../workTime/workTime.module";
import {OpenBillDialogComponent} from "./dialog/openBillExists.component";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {NgxMatSelectSearchModule} from "ngx-mat-select-search";

@NgModule({
    declarations: [
        CustomerComponent,
        CustomerFormComponent,
        CustomerMainSidebarComponent,
        CustomerDetailsSidebarComponent,
        CustomerCardsSidebarComponent,
        CustomerResourcesSidebarComponent,
        CustomerDetailsComponent,
        CustomerPersonalDataComponent,
        CustomerDialogComponent,
        CustomerContactDetailsDialogComponent,
        CustomerDescriptionEditDialogComponent,
        CustomerCardsComponent,
        AddCardComponent,
        AddCardItemComponent,
        ResourcesInUseComponent,
        MinusServiceDialogComponent,
        ExitCardDialogComponent,
        ResourceOnlineComponent,
        CustomerCommunicationComponent,
        OrdersComponent,
        TakeCardDialogComponent,
        CustomerAlreadyExistsDialogComponent,
        OpenBillDialogComponent,
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        FlexLayoutModule,
        MatSelectModule,

        FuseSharedModule,
        FuseSidebarModule,
        MatRippleModule,
        TranslateModule,
        MatToolbarModule,
        MatDialogModule,
        MatTooltipModule,
        MatDatepickerModule,
        MatCheckboxModule,
        MatTreeModule,
        SecurityModule,
        WorkTimeModule,
        MatProgressSpinnerModule,
        NgxMatSelectSearchModule

    ],
    providers: [
        CustomerResolve,
    ],
    exports: [
        CustomerDetailsSidebarComponent,
        CustomerMainSidebarComponent,
    ],
    bootstrap: [
        CustomerComponent,
        CustomerFormComponent,
        CustomerDetailsComponent,
        CustomerPersonalDataComponent,
        CustomerCardsComponent,
        CustomerDialogComponent,
        CustomerContactDetailsDialogComponent,
        CustomerDescriptionEditDialogComponent,
        AddCardComponent,
        AddCardItemComponent,
        ResourcesInUseComponent,
        MinusServiceDialogComponent,
        ExitCardDialogComponent,
        ResourceOnlineComponent,
        CustomerCommunicationComponent,
        OrdersComponent,
        TakeCardDialogComponent,
        CustomerAlreadyExistsDialogComponent,
        OpenBillDialogComponent,
    ]
})
export class CustomerModule { }
